var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWaitingForConfirmationModalImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 223.793,
    height: 135.589,
    viewBox: "0 0 223.793 135.589",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Artwork",
    transform: "translate(0 0.005)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_46",
    "data-name": "Ellipse 46",
    cx: 11.533,
    cy: 11.533,
    r: 11.533,
    transform: "translate(6.994 6.347)",
    fill: "#ff6584"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_47",
    "data-name": "Ellipse 47",
    cx: 111.319,
    cy: 4.513,
    rx: 111.319,
    ry: 4.513,
    transform: "translate(0 126.559)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_48",
    "data-name": "Ellipse 48",
    cx: 28.331,
    cy: 28.331,
    r: 28.331,
    transform: "translate(0 17.852)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_327",
    "data-name": "Path 327",
    d: "M106.55,256.8h-5.8l2.645-89.6Z",
    transform: "translate(-75.488 -125.285)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_328",
    "data-name": "Path 328",
    d: "M111.045,209.176l6.23-8.619-6.315,10.752-.683-1.195Z",
    transform: "translate(-82.629 -150.278)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_329",
    "data-name": "Path 329",
    d: "M92,243.893l-6.229-8.619,6.315,10.752.683-1.195Z",
    transform: "translate(-64.267 -176.291)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_330",
    "data-name": "Path 330",
    d: "M810.164,257.178h-5.8l2.645-89.6Z",
    transform: "translate(-602.694 -125.566)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_331",
    "data-name": "Path 331",
    d: "M814.659,209.552l6.23-8.619-6.315,10.752-.683-1.195Z",
    transform: "translate(-609.835 -150.56)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_332",
    "data-name": "Path 332",
    d: "M795.614,244.269l-6.229-8.619L795.7,246.4l.683-1.195Z",
    transform: "translate(-591.473 -176.572)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 52.777,
    cy: 52.777,
    r: 52.777,
    transform: "translate(62.316 26.043)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_50",
    "data-name": "Ellipse 50",
    cx: 48.408,
    cy: 48.408,
    r: 48.408,
    transform: "translate(66.685 30.412)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_51",
    "data-name": "Ellipse 51",
    cx: 6.466,
    cy: 6.466,
    r: 6.466,
    transform: "translate(108.452 72.529)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_446",
    "data-name": "Rectangle 446",
    width: 2.796,
    height: 5.243,
    transform: "translate(113.52 32.859)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_447",
    "data-name": "Rectangle 447",
    width: 2.796,
    height: 5.243,
    transform: "translate(113.52 119.888)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_448",
    "data-name": "Rectangle 448",
    width: 2.796,
    height: 5.243,
    transform: "translate(74.025 77.596) rotate(90)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_449",
    "data-name": "Rectangle 449",
    width: 2.796,
    height: 5.243,
    transform: "translate(161.054 77.596) rotate(90)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_333",
    "data-name": "Path 333",
    d: "M450.924,309.957l2.39-5.464,29.942,16.583Z",
    transform: "translate(-337.87 -228.155)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_450",
    "data-name": "Rectangle 450",
    width: 13.631,
    height: 15.728,
    transform: "translate(108.277 13.286)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_52",
    "data-name": "Ellipse 52",
    cx: 15.728,
    cy: 4.369,
    rx: 15.728,
    ry: 4.369,
    transform: "translate(99.365 8.917)",
    fill: "#3f3d56"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_334",
    "data-name": "Path 334",
    d: "M715.031,527.627l-.874,1.223s-4.019,4.719-4.194,2.447,2.971-3.845,2.971-3.845l1.748-1.049Z",
    transform: "translate(-570.492 -439.458)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_335",
    "data-name": "Path 335",
    d: "M825.667,547.124l.732,1.313s2.544,5.652.416,4.838-2.2-4.33-2.2-4.33l-.2-2.028Z",
    transform: "translate(-656.251 -454.828)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_53",
    "data-name": "Ellipse 53",
    cx: 5.321,
    cy: 5.321,
    r: 5.321,
    transform: "translate(160.16 58.368)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_336",
    "data-name": "Path 336",
    d: "M811.751,607.166l.7,4.544v1.4h4.019V611.36s.175-3.146-.524-4.019S811.751,607.166,811.751,607.166Z",
    transform: "translate(-646.765 -499.773)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_337",
    "data-name": "Path 337",
    d: "M783.173,607.166l.7,4.544v1.4h4.019V611.36s.175-3.146-.524-4.019S783.173,607.166,783.173,607.166Z",
    transform: "translate(-625.352 -499.773)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_338",
    "data-name": "Path 338",
    d: "M791.394,462.384a1.788,1.788,0,0,0-.49,2.668c1.056,1.853,7.251,21.029,7.251,21.029l3.574-1.015-3.152-12.127-1.8-7.622Z",
    transform: "translate(-630.868 -391.489)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_54",
    "data-name": "Ellipse 54",
    cx: 4.019,
    cy: 4.019,
    r: 4.019,
    transform: "translate(160.879 61.169)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_339",
    "data-name": "Path 339",
    d: "M806.187,442.063l-.524,8.214-3.67-2.621s1.223-4.893.874-5.243Z",
    transform: "translate(-639.453 -376.263)",
    fill: "#ffb8b8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_340",
    "data-name": "Path 340",
    d: "M793.485,462.408l-3.954-2.928s-1.813-.742-2.338.132-3.146,13.806-1.748,16.252c0,0,7.515,1.573,9.087.7l.7-4.544s.874-2.8-.524-4.544Z",
    transform: "translate(-626.751 -389.092)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_341",
    "data-name": "Path 341",
    d: "M742.45,460.648a1.788,1.788,0,0,0-2.621.7c-1.223,1.748-15.9,15.553-15.9,15.553l2.447,2.8,9.612-8.039,6.117-4.893Z",
    transform: "translate(-580.959 -389.954)",
    fill: "#08c4bb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_342",
    "data-name": "Path 342",
    d: "M790.719,525.5s-8.651-1.66-9.524-.437l-.175,1.922s-1.922,3.67-.874,9.612a29.258,29.258,0,0,1,.349,9.612,38.648,38.648,0,0,1,8.214,0c3.5.524,4.019,0,4.019,0Z",
    transform: "translate(-622.85 -438.114)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_343",
    "data-name": "Path 343",
    d: "M816.819,628.868l-5.068.175L813.5,642.15s-1.4,5.592.175,5.942a17.733,17.733,0,0,0,3.32.349,4.816,4.816,0,0,0,3.32,1.4,9.786,9.786,0,0,0,3.32-1.049,1.086,1.086,0,0,0-.874-1.4c-1.223-.35-4.544-1.4-5.243-5.068Z",
    transform: "translate(-646.765 -516.233)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_344",
    "data-name": "Path 344",
    d: "M788.241,628.868l-5.068.175,1.748,13.107s-1.4,5.592.175,5.942a17.732,17.732,0,0,0,3.32.349,4.816,4.816,0,0,0,3.32,1.4,9.786,9.786,0,0,0,3.32-1.049,1.086,1.086,0,0,0-.874-1.4c-1.223-.35-4.544-1.4-5.243-5.068Z",
    transform: "translate(-625.352 -516.233)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_55",
    "data-name": "Ellipse 55",
    cx: 2.202,
    cy: 2.202,
    r: 2.202,
    transform: "translate(165.141 55.886)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_345",
    "data-name": "Path 345",
    d: "M826.966,399.965a2.2,2.2,0,0,0-1.972-2.19,2.23,2.23,0,0,1,.229-.012,2.2,2.2,0,0,1,0,4.4,2.232,2.232,0,0,1-.229-.012A2.2,2.2,0,0,0,826.966,399.965Z",
    transform: "translate(-656.687 -343.07)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_56",
    "data-name": "Ellipse 56",
    cx: 3.67,
    cy: 2.202,
    rx: 3.67,
    ry: 2.202,
    transform: "translate(161.193 60.359)",
    fill: "#2f2e41"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_346",
    "data-name": "Path 346",
    d: "M914.719,190.163a11.2,11.2,0,0,0-21.977-2.362c-.136,0-.271-.01-.408-.01a11.2,11.2,0,0,0-10.747,8.043,7.916,7.916,0,0,0-9.394,2.338h34.94a7.577,7.577,0,0,0,7.593-7.845Q914.724,190.246,914.719,190.163Z",
    transform: "translate(-692.053 -179.599)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_57",
    "data-name": "Ellipse 57",
    cx: 3.009,
    cy: 3.009,
    r: 3.009,
    transform: "translate(190.448 28.121)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_58",
    "data-name": "Ellipse 58",
    cx: 2.505,
    cy: 2.505,
    r: 2.505,
    transform: "translate(200.036 21.531)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_59",
    "data-name": "Ellipse 59",
    cx: 3.009,
    cy: 3.009,
    r: 3.009,
    transform: "translate(211.759 34.64)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_60",
    "data-name": "Ellipse 60",
    cx: 3.009,
    cy: 3.009,
    r: 3.009,
    transform: "translate(188.944 48.429)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_61",
    "data-name": "Ellipse 61",
    cx: 3.009,
    cy: 3.009,
    r: 3.009,
    transform: "translate(211.759 65.729)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_347",
    "data-name": "Path 347",
    d: "M953.823,673.608c0-.033,0-.065,0-.1a4.75,4.75,0,0,0-9.482-.248l-.045,0a8.419,8.419,0,1,0,9.522.348Z",
    transform: "translate(-743.824 -546.858)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_62",
    "data-name": "Ellipse 62",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(216.272 55.449)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_63",
    "data-name": "Ellipse 63",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(208.249 25.363)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_64",
    "data-name": "Ellipse 64",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(203.987 56.452)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_65",
    "data-name": "Ellipse 65",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(204.989 55.199)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_66",
    "data-name": "Ellipse 66",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(205.742 53.945)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_67",
    "data-name": "Ellipse 67",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(202.733 64.475)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_68",
    "data-name": "Ellipse 68",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(221.286 78.515)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_69",
    "data-name": "Ellipse 69",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(194.459 79.267)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_70",
    "data-name": "Ellipse 70",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(195.964 40.657)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_71",
    "data-name": "Ellipse 71",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(201.73 63.221)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_72",
    "data-name": "Ellipse 72",
    cx: 1.254,
    cy: 1.254,
    r: 1.254,
    transform: "translate(200.477 61.216)",
    fill: "#e6e6e6"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaitingForConfirmationModalImage);
export default __webpack_public_path__ + "static/media/waiting-for-confirmation-modal-image.787983f996f67554444154f802c6bd87.svg";
export { ForwardRef as ReactComponent };